import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { AnnotationCreate, AnnotationEdit, AnnotationDelete, DocumentUpdate, AnnotationBatchUpsert } from '../models/annotation-modification';
export var DocumentUpdateAggregatePolicy = /*#__PURE__*/function () {
  function DocumentUpdateAggregatePolicy(batchUpsertOperations) {
    _classCallCheck(this, DocumentUpdateAggregatePolicy);
    this.batchUpsertOperations = batchUpsertOperations;
  }
  return _createClass(DocumentUpdateAggregatePolicy, [{
    key: "apply",
    value: function apply(input) {
      var documentUpdates = input.filter(function (modification) {
        return modification instanceof DocumentUpdate;
      }).map(function (modification) {
        return modification;
      });
      var wasDocumentUpdated = documentUpdates.length > 0 && !this.areDocumentUpdatesMutuallyLeveled(documentUpdates);
      if (wasDocumentUpdated) {
        return [documentUpdates[0]];
      }
      var annotationsModifications = input.filter(function (modification) {
        return modification instanceof AnnotationCreate || modification instanceof AnnotationEdit || modification instanceof AnnotationDelete;
      }).map(function (modification) {
        return modification;
      });
      var flattenedModificationsList = this.flattenModifications(annotationsModifications);
      var result = this.batchUpsertOperations ? this.batchUpserts(flattenedModificationsList) : flattenedModificationsList;
      return result;
    }
  }, {
    key: "flattenModifications",
    value: function flattenModifications(input) {
      var flattenedModificationsList = [];
      var _iterator = _createForOfIteratorHelper(input),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var modification = _step.value;
          if (modification instanceof AnnotationCreate) {
            flattenedModificationsList.push(modification);
          } else if (modification instanceof AnnotationEdit) {
            this.processEditModification(modification, flattenedModificationsList);
          } else if (modification instanceof AnnotationDelete) {
            this.processDeleteModification(modification, flattenedModificationsList);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return flattenedModificationsList;
    }
  }, {
    key: "processEditModification",
    value: function processEditModification(editedAnnotation, modificationsList) {
      var index = modificationsList.findIndex(function (m) {
        return m.annotationId === editedAnnotation.annotationId;
      });
      if (index === -1) {
        modificationsList.push(editedAnnotation);
      } else {
        var newOrEdited = modificationsList[index];
        if (newOrEdited instanceof AnnotationCreate) {
          modificationsList[index] = new AnnotationCreate(editedAnnotation.annotationId, editedAnnotation.annotation);
        } else {
          modificationsList[index] = editedAnnotation;
        }
      }
    }
  }, {
    key: "processDeleteModification",
    value: function processDeleteModification(deletedAnnotation, modificationsList) {
      var index = modificationsList.findIndex(function (m) {
        return m.annotationId === deletedAnnotation.annotationId;
      });
      if (index === -1) {
        modificationsList.push(deletedAnnotation);
      } else {
        var newOrEdited = modificationsList.splice(index, 1)[0];
        if (newOrEdited instanceof AnnotationEdit) {
          modificationsList.push(deletedAnnotation);
        }
      }
    }
  }, {
    key: "batchUpserts",
    value: function batchUpserts(modifications) {
      var result = [];
      var upsertedAnnotations = modifications.filter(function (modification) {
        return modification instanceof AnnotationCreate || modification instanceof AnnotationEdit;
      }).map(function (modification) {
        return modification.annotation;
      });
      if (upsertedAnnotations.length > 0) {
        result.push(new AnnotationBatchUpsert(upsertedAnnotations));
      }
      var deleteModifications = modifications.filter(function (modification) {
        return modification instanceof AnnotationDelete;
      });
      result.push.apply(result, _toConsumableArray(deleteModifications));
      return result;
    }
  }, {
    key: "areDocumentUpdatesMutuallyLeveled",
    value: function areDocumentUpdatesMutuallyLeveled(_updates) {
      return false;
    }
  }]);
}();
